import { Badge, type BadgeProps } from '@/components/base/badge'
import { cn } from '@/helpers/utils'

interface BadgeRoomHeaderProps extends BadgeProps {
  isVisible: boolean
}

export const BadgeRoomHeader = ({
  children,
  className,
  isVisible,
  ...props
}: BadgeRoomHeaderProps) => {
  return (
    <Badge
      className={cn(
        'pointer-events-none invisible absolute right-0 top-0 mt-1 translate-x-1/4 translate-y-full rounded-full border-[1.5px] border-primary bg-negative-light px-1.5 py-0.5 text-xs text-background',
        className,
        isVisible && 'visible',
      )}
      variant="outline"
      {...props}
    >
      {children}
    </Badge>
  )
}
